/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M12 0C9.1005 0 6.75 2.3505 6.75 5.25V9H4.5c-1.6568 0-3 1.3431-3 3v9c0 1.6569 1.3432 3 3 3h15c1.6569 0 3-1.3431 3-3v-9c0-1.6569-1.3431-3-3-3h-2.25V5.25l-.0078-.288C17.0927 2.1963 14.8028 0 12 0ZM8.25 5.25C8.25 3.179 9.929 1.5 12 1.5c.9901 0 1.8906.3837 2.5609 1.0106.6808.6367 1.1241 1.5242 1.1825 2.5152.0044.0742.0066.149.0066.2242V9h-7.5V5.25ZM12 19.5c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z"
    clipRule="evenodd"
  />,
  'MenuPermissionsFilled'
);
